import withStore, { TLoadingAwarePresenter, TPresentable } from "../withStore";
import Application from "../../Application";
import LoginInteractor from "../../interactor/authentication/LoginInteractor";
import { Errors } from "../../common/Constants";
import ShowErrorMessageInteractor from "../../interactor/notifications/ShowErrorMessageInteractor";

export interface TVerificationPresenter extends TLoadingAwarePresenter {
  verificationCode: string;
  username: string;
  password: string;
  redirectRoute?: string;
}
export interface IVerificationPresenter
  extends TVerificationPresenter,
    TPresentable {
  loadVerificationCode(verificationCode: string): void;
  onChangeVerificationCode(verificationCode: string): void;
  submitVerificationCode(): void;
}

const defaultState: TVerificationPresenter = {
  verificationCode: "",
  username: "",
  password: "",
  redirectRoute: ""
};

const VerificationPresenter = withStore<
  IVerificationPresenter,
  TVerificationPresenter
>(({ application, store, loader, translate }): IVerificationPresenter => {
  const _store = store;
  const _application: Application = application;
  const state = _store.getState<TVerificationPresenter>();

  const loadVerificationCode = (verificationCode: string) => {
    _store.update({
      verificationCode
    });
  };

  const onChangeVerificationCode = (verificationCode: string) => {
    _store.update({
      verificationCode
    });
  };

  const submitVerificationCode = async () => {
    loader.start("verificationLoader");
    const { username, password, verificationCode, redirectRoute } =
      _store.getState<TVerificationPresenter>();

    let error = await application.container
      .resolve<LoginInteractor>("login")
      .execute(username, password, verificationCode, redirectRoute);

    if (error && error.code === Errors.LOGIN_ERROR) {
      loader.stop("loginLoader");
      _application.container
        .resolve<ShowErrorMessageInteractor>("showErrorMessage")
        .execute((error as any).message);
    }

    loader.stop("verificationLoader");
  };

  return {
    ...state,
    store: _store,
    loader,
    application: _application,
    translate,
    loadVerificationCode,
    onChangeVerificationCode,
    submitVerificationCode
  };
}, defaultState);

export default VerificationPresenter;
